/**
 * S1.5 (KONZEPT-GEDAECHTNIS.md § 5): welchen Datensatz hat der Betreiber gerade offen — als
 * Client-Behauptung an den Agent-Worker mitgeschickt (unverifiziert; beforeTurn() prueft
 * Existenz+Mandant server-seitig nach, bevor daraus Fakten/Playbook-Scope werden).
 *
 * Deckt sich mit `ZielBereich` aus apps/agent/src/werkzeuge/ziel.ts — dieselbe kleine Liste, die
 * ueberhaupt eine eigene Adresse hat. Reine Funktion (kein React-Import), pruefbar ohne DOM.
 */
export type ZielBereich = "veranstaltung" | "angebot" | "kunde" | "anfrage" | "speisekarten_import";

export interface ActiveRecord {
  bereich: ZielBereich;
  id: string;
}

const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/** Bildet die aktuelle Route auf den offenen Datensatz ab, oder null (keine Detailseite offen /
 * Id fehlt / keine gueltige Uuid). `search` roh uebergeben (mit oder ohne fuehrendem "?"). */
export function routeToRecord(pathname: string, search: string): ActiveRecord | null {
  const q = new URLSearchParams(search);
  const seg = pathname.split("/").filter(Boolean);

  // /vorgaenge/:id[/angebot] (F0-Umbenennung) bzw. die alte, weiterhin uebergangsweise
  // erreichbare /veranstaltungen/:id[/angebot] - der Angebots-Builder hat keine eigene Adresse,
  // die Event-Id IST die Adresse (siehe ziel.ts). `bereich` bleibt "veranstaltung" - das ist der
  // von apps/agent/src/werkzeuge/ziel.ts geteilte Wert, dessen Umbenennung ausserhalb dieses
  // Frontend-Arbeitspakets liegt (AP10, Backend).
  if ((seg[0] === "vorgaenge" || seg[0] === "veranstaltungen") && UUID.test(seg[1] ?? "")) {
    return { bereich: seg[2] === "angebot" ? "angebot" : "veranstaltung", id: seg[1]! };
  }
  if (seg[0] === "kunden" && UUID.test(seg[1] ?? "")) {
    return { bereich: "kunde", id: seg[1]! };
  }
  // Schubladen-auf-Listenseite tragen die Id im Query-String, nicht im Pfad.
  if (seg[0] === "anfragen" && UUID.test(q.get("open") ?? "")) {
    return { bereich: "anfrage", id: q.get("open")! };
  }
  if (seg[0] === "katalog" && seg[1] === "import" && UUID.test(q.get("importId") ?? "")) {
    return { bereich: "speisekarten_import", id: q.get("importId")! };
  }
  return null;
}
